import { SwapRightOutlined } from '@ant-design/icons';
import { Flex, Space, Typography } from 'antd';
import { InputNumberProps } from 'antd/lib/input-number';
import classNames from 'classnames';
import { HTMLInputTypeAttribute } from 'react';

import { SIMPLE_DATE_FORMAT } from 'technical/string/formatter';
import { DateRangeValue } from 'technical/types';
import { MobileDatePicker } from 'ui/form/date-picker/mobile-picker';

import styles from './index.module.scss';

export type MobileRangePickerProps = {
  value?: DateRangeValue;
  onChange?: (value: DateRangeValue) => void;
  allowClear?: boolean;
  leftInputProps?: InputNumberProps;
  leftTitle?: string;
  rightInputProps?: InputNumberProps;
  rightTitle?: string;
  className?: string;
  format?: string;
  picker?: Extract<
    HTMLInputTypeAttribute,
    'datetime-local' | 'date' | 'week' | 'month'
  >;
};

export const MobileRangePicker = ({
  value,
  onChange,
  leftTitle,
  rightTitle,
  className,
  picker,
}: Readonly<MobileRangePickerProps>) => {
  const leftInputId = `leftInput-${leftTitle}`;
  const rightInputId = `rightInput-${rightTitle}`;

  return (
    <Flex
      className={classNames(
        styles.rangeInput,
        styles.customPicker,
        className,
        //custom picker is duplicate of  'ant-input ant-picker ant-picker-range ant-picker-outlined',
      )}
    >
      <Space>
        {leftTitle ? (
          <label htmlFor={leftInputId}>
            <Typography.Text type="secondary">{leftTitle}</Typography.Text>
          </label>
        ) : null}
        <MobileDatePicker
          styled={false}
          id={leftTitle ? leftInputId : undefined}
          picker={picker}
          value={value?.[0]?.format(SIMPLE_DATE_FORMAT)}
          onChange={(inputValue) => {
            if (!onChange) {
              return;
            }

            onChange([
              inputValue.isValid() ? inputValue : null,
              value ? value[1] : null,
            ]);
          }}
        />
      </Space>
      <SwapRightOutlined
        className={
          styles.customPickerSeparator
          // duplicate of native ant class 'ant-picker-separator'
        }
      />
      <Space>
        {rightTitle ? (
          <label htmlFor={rightInputId}>
            <Typography.Text type="secondary">{rightTitle}</Typography.Text>
          </label>
        ) : null}
        <MobileDatePicker
          styled={false}
          id={rightTitle ? rightInputId : undefined}
          picker={picker}
          value={value?.[1]?.format(SIMPLE_DATE_FORMAT)}
          onChange={(inputValue) => {
            if (!onChange) {
              return;
            }

            onChange([
              value ? value[0] : null,
              inputValue.isValid() ? inputValue : null,
            ]);
          }}
        />
      </Space>
    </Flex>
  );
};
